import { createStyles } from '@/contexts/theme-context';
import { StyleProp, View, ViewStyle } from 'react-native';
import { Typography } from '@usepepper/ui/atoms/typography';

interface EmptyStateProps {
  bottomElement?: React.ReactNode;
  containerStyle?: StyleProp<ViewStyle>;
  description?: string;
  iconElement: React.ReactNode;
  title: string;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  bottomElement,
  containerStyle,
  iconElement,
  title,
  description,
}) => {
  const [styles, theme] = useStyles();

  return (
    <View style={[styles.container, containerStyle]}>
      {iconElement}
      <View style={styles.content}>
        <Typography
          color={theme.sk.color.text.primary}
          textAlign="center"
          variant="paragraph-base-600"
        >
          {title}
        </Typography>
        <Typography
          color={theme.sk.color.text.secondary}
          textAlign="center"
          variant="paragraph-md"
        >
          {description}
        </Typography>
      </View>
      {bottomElement}
    </View>
  );
};

const useStyles = createStyles(() => ({
  container: {
    alignItems: 'center',
    flex: 1,
    gap: 16,
    justifyContent: 'center',
    pointerEvents: 'box-none',
  },
  content: {
    gap: 4,
    width: 300,
  },
}));
